<template>
  <span :class="['tw-inline-flex tw-items-center tw-rounded-full tw-font-normal tw-whitespace-nowrap', colorClass, sizeClass]">
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "primary",
      validator: (value) => ["primary", "secondary", "red", "green", "gray", "yellow"].indexOf(value) !== -1,
    },
    size: {
      type: String,
      default: "md",
      validator: (value) => ["xs", "sm", "md"].indexOf(value) !== -1,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colorClass() {
      return this.dark ? `tw-bg-${this.color}-600 tw-text-${this.color}-100` : `tw-bg-${this.color}-100 tw-text-${this.color}-600`;
    },
    sizeClass() {
      let returnClass = "";

      switch (this.size) {
        case "xs":
          returnClass = "tw-px-1.5 tw-py-0.4 tw-text-xxs tw-leading-4";
          break;
        case "sm":
          returnClass = "tw-px-2.5 tw-py-0.5 tw-text-xs tw-leading-4";
          break;
        case "md":
          returnClass = "tw-px-3 tw-py-0.5 tw-text-sm tw-leading-5";
          break;
        default:
          returnClass = "tw-px-3 tw-py-0.5 tw-text-sm tw-leading-5";
          break;
      }
      return returnClass;
    },
  },
};
</script>
<style scoped>
.tw-text-xxs {
  font-size: 0.7rem;
}
</style>
